"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4873],{

/***/ 6834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AG": function() { return /* binding */ nullable; },
/* harmony export */   "FX": function() { return /* binding */ getAddStringContext; },
/* harmony export */   "n1": function() { return /* binding */ addCustomAttributes; },
/* harmony export */   "uR": function() { return /* binding */ numeric; }
/* harmony export */ });
/* harmony import */ var _util_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4155);
/* harmony import */ var _config_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3807);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */



var hasOwnProp = Object.prototype.hasOwnProperty;
var MAX_ATTRIBUTES = 64;
function nullable(val, fn, comma) {
  return val || val === 0 || val === '' ? fn(val) + (comma ? ',' : '') : '!';
}
function numeric(n, noDefault) {
  if (noDefault) {
    return Math.floor(n).toString(36);
  }
  return n === undefined || n === 0 ? '' : Math.floor(n).toString(36);
}
function getAddStringContext(agentIdentifier) {
  let stringTableIdx = 0;
  const stringTable = Object.prototype.hasOwnProperty.call(Object, 'create') ? Object.create(null) : {};
  const obfuscator = (0,_config_runtime__WEBPACK_IMPORTED_MODULE_1__/* .getRuntime */ .O)(agentIdentifier).obfuscator;
  return addString;
  function addString(str) {
    if (typeof str === 'undefined' || str === '') return '';
    str = obfuscator.obfuscateString(String(str));
    if (hasOwnProp.call(stringTable, str)) {
      return numeric(stringTable[str], true);
    } else {
      stringTable[str] = stringTableIdx++;
      return quoteString(str);
    }
  }
}
function addCustomAttributes(attrs, addString) {
  var attrParts = [];
  Object.entries(attrs || {}).forEach(([key, val]) => {
    if (attrParts.length >= MAX_ATTRIBUTES) return;
    var type = 5;
    var serializedValue;
    // add key to string table first
    key = addString(key);
    switch (typeof val) {
      case 'object':
        if (val) {
          // serialize objects to strings
          serializedValue = addString((0,_util_stringify__WEBPACK_IMPORTED_MODULE_0__/* .stringify */ .P)(val));
        } else {
          // null attribute type
          type = 9;
        }
        break;
      case 'number':
        type = 6;
        // make sure numbers contain a `.` so they are parsed as doubles
        serializedValue = val % 1 ? val : val + '.';
        break;
      case 'boolean':
        type = val ? 7 : 8;
        break;
      case 'undefined':
        // we treat undefined as a null attribute (since dirac does not have a concept of undefined)
        type = 9;
        break;
      default:
        serializedValue = addString(val);
    }
    attrParts.push([type, key + (serializedValue ? ',' + serializedValue : '')]);
  });
  return attrParts;
}
var escapable = /([,\\;])/g;
function quoteString(str) {
  return "'" + str.replace(escapable, '\\$1');
}

/***/ }),

/***/ 8909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Aggregate": function() { return /* binding */ Aggregate; }
});

// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/register-handler.js
var register_handler = __webpack_require__(5992);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/url/parse-url.js
var parse_url = __webpack_require__(8490);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/deny-list/deny-list.js
var deny_list = __webpack_require__(4741);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/timing/nav-timing.js
var nav_timing = __webpack_require__(1131);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/ids/unique-id.js
var unique_id = __webpack_require__(765);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/config/info.js
var config_info = __webpack_require__(8312);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/constants/runtime.js
var runtime = __webpack_require__(9152);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/window/nreum.js
var nreum = __webpack_require__(3131);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/contextual-ee.js
var contextual_ee = __webpack_require__(5891);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/spa/aggregate/interaction-node.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

var MAX_NODES = 128;
var lastId = 0;
function InteractionNode(interaction, parent, type, timestamp) {
  Object.defineProperty(this, 'interaction', {
    value: interaction,
    writable: true // enumerable: false -- by default, which hides this prop from obj (iterations)
  });
  this.parent = parent;
  this.id = ++lastId;
  this.type = type;
  this.children = [];
  this.end = null;
  this.jsEnd = this.start = timestamp;
  this.jsTime = 0;
  this.attrs = {};
  this.cancelled = false;
}
var InteractionNodePrototype = InteractionNode.prototype;

/**
 * @param {string} type
 * @param {number} timestamp
 * @param {string} name
 * @param {bool} dontWait - When true, the interaction will not immediately start waiting
 *                          for this node to complete. This is used when the creation of
 *                          the node and its start happen at different times (e.g. XHR).
 */
InteractionNodePrototype.child = function child(type, timestamp, name, dontWait) {
  var interaction = this.interaction;
  if (interaction.end || interaction.nodes >= MAX_NODES) return null;
  interaction.onNodeAdded(this);
  var node = new InteractionNode(interaction, this, type, timestamp);
  node.attrs.name = name;
  interaction.nodes++;
  if (!dontWait) {
    interaction.remaining++;
  }
  return node;
};
InteractionNodePrototype.callback = function addCallbackTime(exclusiveTime, end) {
  var node = this;
  node.jsTime += exclusiveTime;
  if (end > node.jsEnd) {
    node.jsEnd = end;
    node.interaction.lastCb = end;
  }
};
InteractionNodePrototype.cancel = function cancel() {
  this.cancelled = true;
  var interaction = this.interaction;
  interaction.remaining--;
};
InteractionNodePrototype.finish = function finish(timestamp) {
  var node = this;
  if (node.end) return;
  node.end = timestamp;

  // Find the next parent node that is not cancelled
  let parent = node.parent;
  while (parent?.cancelled) parent = parent.parent;

  // Assign the node to the non-cancelled parent node
  if (parent) parent.children.push(node);
  node.parent = null;

  // Update the interaction remaining counter
  var interaction = this.interaction;
  interaction.remaining--;
  interaction.lastFinish = timestamp;
  // check if interaction has finished, (this is needed for older browsers for unknown reasons)
  interaction.checkFinish();
};
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/spa/aggregate/interaction.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */






var originalSetTimeout = (0,nreum/* gosNREUMOriginals */.mF)().o.ST;
var originalClearTimeout = (0,nreum/* gosNREUMOriginals */.mF)().o.CT;
var interaction_lastId = {};
function Interaction(eventName, timestamp, url, routeName, onFinished, agentIdentifier) {
  this.agentIdentifier = agentIdentifier;
  this.ee = contextual_ee.ee.get(agentIdentifier);
  interaction_lastId[agentIdentifier] = 0;
  this.id = ++interaction_lastId[agentIdentifier];
  this.eventName = eventName;
  this.nodes = 0;
  this.remaining = 0;
  this.finishTimer = null;
  this.checkingFinish = false;
  this.lastCb = this.lastFinish = timestamp;
  this.handlers = [];
  this.onFinished = onFinished;
  this.done = false;
  var root = this.root = new InteractionNode(this, null, 'interaction', timestamp);
  var attrs = root.attrs;
  attrs.trigger = eventName;
  attrs.initialPageURL = runtime/* initialLocation */.FN;
  attrs.oldRoute = routeName;
  attrs.newURL = attrs.oldURL = url;
  attrs.custom = {};
  attrs.store = {};
}
var InteractionPrototype = Interaction.prototype;
InteractionPrototype.checkFinish = function checkFinish() {
  var interaction = this;
  if (interaction.remaining > 0) {
    interaction._resetFinishCheck();
    return;
  }
  if (interaction.checkingFinish) {
    return;
  }
  if (interaction.root.end !== null) return;
  interaction._resetFinishCheck();
  interaction.checkingFinish = true;
  interaction.finishTimer = originalSetTimeout(() => {
    interaction.checkingFinish = false;
    interaction.finishTimer = originalSetTimeout(() => {
      interaction.finishTimer = null;
      if (interaction.remaining <= 0) interaction.finish();
    }, 1);
  }, 0);
};
InteractionPrototype.setNewURL = function setNewURL(url) {
  this.root.attrs.newURL = url;
};
InteractionPrototype.setNewRoute = function setNewRoute(route) {
  this.root.attrs.newRoute = route;
};
InteractionPrototype.onNodeAdded = function onNodeAdded() {
  this._resetFinishCheck();
};
InteractionPrototype._resetFinishCheck = function _resetFinishCheck() {
  if (this.finishTimer) {
    originalClearTimeout(this.finishTimer);
    this.finishTimer = null;
    this.checkingFinish = false;
  }
};

// serialize report and remove nodes from map
InteractionPrototype.finish = function finishInteraction() {
  var interaction = this;
  var root = interaction.root;
  if (root.end !== null) return;
  var endTimestamp = Math.max(interaction.lastCb, interaction.lastFinish);
  var attrs = root.attrs;
  var customAttrs = attrs.custom;
  if (this.onFinished) {
    this.onFinished(this);
  }
  Object.entries((0,config_info/* getInfo */.C5)(interaction.agentIdentifier).jsAttributes || {}).forEach(([attr, value]) => {
    if (!(attr in customAttrs)) customAttrs[attr] = value;
  });
  root.end = endTimestamp;
  interaction.ee.emit('interaction', [this]);
};
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-listener/event-listener-opts.js
var event_listener_opts = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/url/clean-url.js
var clean_url = __webpack_require__(1478);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/serialize/bel-serializer.js
var bel_serializer = __webpack_require__(6834);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/console.js
var console = __webpack_require__(1639);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/context/shared-context.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

const model = {
  agentIdentifier: '',
  ee: undefined
};
class SharedContext {
  constructor(context) {
    try {
      if (typeof context !== 'object') return (0,console/* warn */.Z)(8);
      this.sharedContext = {};
      Object.assign(this.sharedContext, model);
      Object.entries(context).forEach(([key, value]) => {
        if (Object.keys(model).includes(key)) this.sharedContext[key] = value;
      });
    } catch (err) {
      (0,console/* warn */.Z)(9, err);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/spa/aggregate/serializer.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */




class Serializer extends SharedContext {
  constructor(parent) {
    super(parent);

    /**
     * This variable is used to calculate an interactions ending offset when the
     * harvest includes multiple interactions. This variable is set by the first
     * interaction processed and used by subsequent interactions in the same harvest.
     * See https://issues.newrelic.com/browse/NEWRELIC-5498
     * @type {number|undefined}
     */
    this.firstTimestamp = undefined;
  }
  serializeMultiple(interactions, offset, navTiming) {
    const info = (0,config_info/* getInfo */.C5)(this.sharedContext.agentIdentifier);
    var addString = (0,bel_serializer/* getAddStringContext */.FX)(this.sharedContext.agentIdentifier);
    var serialized = 'bel.7';
    interactions.forEach(interaction => {
      serialized += ';' + this.serializeInteraction(interaction.root, offset, navTiming, interaction.routeChange, addString, info);
    });
    this.firstTimestamp = undefined;
    return serialized;
  }
  serializeSingle(root, offset, navTiming, isRouteChange) {
    const info = (0,config_info/* getInfo */.C5)(this.sharedContext.agentIdentifier);
    var addString = (0,bel_serializer/* getAddStringContext */.FX)(this.sharedContext.agentIdentifier);
    var serialized = 'bel.7;' + this.serializeInteraction(root, offset, navTiming, isRouteChange, addString, info);
    this.firstTimestamp = undefined;
    return serialized;
  }
  serializeInteraction(root, offset, navTiming, isRouteChange, addString, info) {
    offset = offset || 0;
    var isInitialPage = root.attrs.trigger === 'initialPageLoad';
    var typeIdsByName = {
      interaction: 1,
      ajax: 2,
      customTracer: 4
    };

    // Include the hash fragment with all SPA data
    var includeHashFragment = true;
    const addNode = (node, nodeList) => {
      if (node.type === 'customEnd') return nodeList.push([3, (0,bel_serializer/* numeric */.uR)(node.end - this.firstTimestamp)]);
      var typeName = node.type;
      var typeId = typeIdsByName[typeName];
      var startTimestamp = node.start;
      var childCount = node.children.length;
      var attrCount = 0;
      var apmAttributes = info.atts;
      var hasNavTiming = isInitialPage && navTiming.length && typeId === 1;
      var children = [];
      var attrs = node.attrs;
      var metrics = attrs.metrics;
      var params = attrs.params;
      var queueTime = info.queueTime;
      var appTime = info.applicationTime;
      if (typeof this.firstTimestamp === 'undefined') {
        startTimestamp += offset;
        this.firstTimestamp = startTimestamp;
      } else {
        startTimestamp -= this.firstTimestamp;
      }
      var fields = [(0,bel_serializer/* numeric */.uR)(startTimestamp), (0,bel_serializer/* numeric */.uR)(node.end - node.start), (0,bel_serializer/* numeric */.uR)(node.jsEnd - node.end), (0,bel_serializer/* numeric */.uR)(node.jsTime)];
      switch (typeId) {
        case 1:
          fields[2] = (0,bel_serializer/* numeric */.uR)(node.jsEnd - this.firstTimestamp);
          fields.push(addString(attrs.trigger), addString((0,clean_url/* cleanURL */.f)(attrs.initialPageURL, includeHashFragment)), addString((0,clean_url/* cleanURL */.f)(attrs.oldURL, includeHashFragment)), addString((0,clean_url/* cleanURL */.f)(attrs.newURL, includeHashFragment)), addString(attrs.customName), isInitialPage ? '' : isRouteChange ? 1 : 2, (0,bel_serializer/* nullable */.AG)(isInitialPage && queueTime, bel_serializer/* numeric */.uR, true) + (0,bel_serializer/* nullable */.AG)(isInitialPage && appTime, bel_serializer/* numeric */.uR, true) + (0,bel_serializer/* nullable */.AG)(attrs.oldRoute, addString, true) + (0,bel_serializer/* nullable */.AG)(attrs.newRoute, addString, true) + addString(attrs.id), addString(node.id), (0,bel_serializer/* nullable */.AG)(attrs.firstPaint, bel_serializer/* numeric */.uR, true) + (0,bel_serializer/* nullable */.AG)(attrs.firstContentfulPaint, bel_serializer/* numeric */.uR, false));
          var attrParts = (0,bel_serializer/* addCustomAttributes */.n1)(attrs.custom, addString);
          children = children.concat(attrParts);
          attrCount = attrParts.length;
          if (apmAttributes) {
            childCount++;
            children.push('a,' + addString(apmAttributes));
          }
          break;
        case 2:
          fields.push(addString(params.method), (0,bel_serializer/* numeric */.uR)(params.status), addString(params.host), addString(params.pathname), (0,bel_serializer/* numeric */.uR)(metrics.txSize), (0,bel_serializer/* numeric */.uR)(metrics.rxSize), attrs.isFetch ? 1 : attrs.isJSONP ? 2 : '', addString(node.id), (0,bel_serializer/* nullable */.AG)(node.dt && node.dt.spanId, addString, true) + (0,bel_serializer/* nullable */.AG)(node.dt && node.dt.traceId, addString, true) + (0,bel_serializer/* nullable */.AG)(node.dt && node.dt.timestamp, bel_serializer/* numeric */.uR, false));

          // add params.gql here
          if (Object.keys(params?.gql || {}).length) {
            var ajaxAttrParts = (0,bel_serializer/* addCustomAttributes */.n1)(params.gql, addString);
            children = children.concat(ajaxAttrParts);
            attrCount = ajaxAttrParts.length;
          }
          break;
        case 4:
          var tracedTime = attrs.tracedTime;
          fields.push(addString(attrs.name), (0,bel_serializer/* nullable */.AG)(tracedTime, bel_serializer/* numeric */.uR, true) + addString(node.id));
          break;
      }
      for (var i = 0; i < node.children.length; i++) {
        addNode(node.children[i], children);
      }
      fields.unshift((0,bel_serializer/* numeric */.uR)(typeId), (0,bel_serializer/* numeric */.uR)(childCount += attrCount));
      nodeList.push(fields);
      if (childCount) {
        nodeList.push(children.join(';'));
      }
      if (hasNavTiming) {
        // this build up the navTiming node
        // it for each navTiming value (pre aggregated in nav-timing.js):
        // we initialize the seperator to ',' (seperates the nodeType id from the first value)
        // we initialize the navTiming node to 'b' (the nodeType id)
        // if the value is present:
        //   we add the seperator followed by the value
        // otherwise
        //   we add null seperator ('!') to the navTimingNode
        //   we set the seperator to an empty string since we already wrote it above
        //   the reason for writing the null seperator instead of setting the seperator
        //   is to ensure we still write it if the null is the last navTiming value.

        var seperator = ',';
        var navTimingNode = 'b';
        var prev = 0;

        // get all navTiming values except navigationStart
        // (since its the same as interaction.start)
        // and limit to just the first 20 values we know about
        Object.values(navTiming.slice(1, 21) || {}).forEach(v => {
          if (v !== undefined) {
            navTimingNode += seperator + (0,bel_serializer/* numeric */.uR)(v - prev);
            seperator = ',';
            prev = v;
          } else {
            navTimingNode += seperator + '!';
            seperator = '';
          }
        });
        nodeList.push(navTimingNode);
      } else if (typeId === 1) {
        nodeList.push('');
      }
      return nodeList;
    };
    return addNode(root, []).join(';');
  }
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/spa/constants.js
var constants = __webpack_require__(9816);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/loaders/features/features.js
var features = __webpack_require__(4663);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/aggregate-base.js + 7 modules
var aggregate_base = __webpack_require__(7410);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/first-contentful-paint.js
var first_contentful_paint = __webpack_require__(3892);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/first-paint.js
var first_paint = __webpack_require__(3600);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/ids/bundle-id.js
var bundle_id = __webpack_require__(2965);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/handle.js
var handle = __webpack_require__(5300);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/metrics/constants.js + 1 modules
var metrics_constants = __webpack_require__(3705);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/spa/aggregate/index.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
/* eslint no-undef: "error" */



















const {
  FEATURE_NAME,
  INTERACTION_EVENTS,
  MAX_TIMER_BUDGET,
  FN_START,
  FN_END,
  CB_START,
  INTERACTION_API,
  REMAINING,
  INTERACTION,
  SPA_NODE,
  JSONP_NODE,
  FETCH_START,
  FETCH_DONE,
  FETCH_BODY,
  JSONP_END,
  originalSetTimeout: aggregate_originalSetTimeout
} = constants;
class Aggregate extends aggregate_base/* AggregateBase */.m {
  static featureName = FEATURE_NAME;
  constructor(agentRef) {
    super(agentRef, FEATURE_NAME);
    const state = this.state = {
      initialPageURL: runtime/* initialLocation */.FN,
      lastSeenUrl: runtime/* initialLocation */.FN,
      lastSeenRouteName: null,
      timerMap: {},
      timerBudget: MAX_TIMER_BUDGET,
      currentNode: null,
      prevNode: null,
      nodeOnLastHashUpdate: null,
      initialPageLoad: null,
      pageLoaded: false,
      childTime: 0,
      depth: 0,
      // The below feature flag is used to disable the SPA ajax fix for specific customers, see https://new-relic.atlassian.net/browse/NR-172169
      disableSpaFix: (agentRef.init.feature_flags || []).indexOf('disable-spa-fix') > -1
    };
    this.spaSerializerClass = new Serializer(this);
    const classThis = this;
    const baseEE = contextual_ee.ee.get(agentRef.agentIdentifier); // <-- parent baseEE
    const mutationEE = baseEE.get('mutation');
    const promiseEE = baseEE.get('promise');
    const historyEE = baseEE.get('history');
    const eventsEE = baseEE.get('events'); // ajax --> ee(123).emit() ee()
    const timerEE = baseEE.get('timer');
    const fetchEE = baseEE.get('fetch');
    const jsonpEE = baseEE.get('jsonp');
    const xhrEE = baseEE.get('xhr');
    const tracerEE = baseEE.get('tracer');

    // childTime is used when calculating exclusive time for a cb duration.
    //
    // Exclusive time will be different than the total time for either callbacks
    // which synchronously invoke a customTracer callback or, trigger a synchronous
    // event (eg. onreadystate=1 or popstate).
    //
    // At fn-end, childTime will contain the total time of all timed callbacks and
    // event handlers which executed as a child of the current callback. At the
    // begining of every callback, childTime is saved to the event context (which at
    // that time contains the sum of its preceeding siblings) and is reset to 0. The
    // callback is then executed, and its children may increase childTime.  At the
    // end of the callback, it reports its exclusive time as its
    // execution time - exlcuded. childTime is then reset to its previous
    // value, and the totalTime of the callback that just finished executing is
    // added to the childTime time.
    //                                    | clock | childTime | ctx.ct | totalTime | exclusive |
    // click fn-start                     |   0   |    0     |    0   |           |           |
    //  | click begining:                 |   5   |    0     |    0   |           |           |
    //  |   | custom-1 fn-start           |   10  |    0     |    0   |           |           |
    //  |   |   |  custom-1 begining      |   15  |    0     |    0   |           |           |
    //  |   |   |    |  custom-2 fn-start |   20  |    0     |    0   |           |           |
    //  |   |   |    |  | custom-2        |   25  |    0     |    0   |           |           |
    //  |   |   |    |  custom-2 fn-end   |   30  |    10    |    0   |     10    |     10    |
    //  |   |   |  custom-1 middle        |   35  |    10    |    0   |           |           |
    //  |   |   |    |  custom-3 fn-start |   40  |    0     |    10  |           |           |
    //  |   |   |    |  | custom-3        |   45  |    0     |    10  |           |           |
    //  |   |   |    |  custom-3 fn-end   |   50  |    20    |    0   |     10    |     10    |
    //  |   |   |  custom-1 ending        |   55  |    20    |    0   |           |           |
    //  |     custom-1 fn-end             |   60  |    50    |    0   |     50    |     30    |
    //  | click ending:                   |   65  |    50    |        |           |           |
    // click fn-end                       |   70  |    0     |    0   |     70    |     20    |

    let harvester;
    this.waitForFlags(['spa']).then(([spaFlag]) => {
      if (spaFlag) {
        harvester = agentRef.runtime.harvester; // since this is after RUM call, PVE would've initialized harvester by now
        this.drain();
      } else {
        this.blocked = true;
        this.deregisterDrain();
      }
    });
    if (agentRef.init.spa.enabled !== true) return;
    state.initialPageLoad = new Interaction('initialPageLoad', 0, state.lastSeenUrl, state.lastSeenRouteName, onInteractionFinished, agentRef.agentIdentifier);
    state.initialPageLoad.save = true;
    state.prevInteraction = state.initialPageLoad;
    state.currentNode = state.initialPageLoad.root; // hint
    // ensure that checkFinish calls are safe during initialPageLoad
    state.initialPageLoad[REMAINING]++;
    (0,register_handler/* registerHandler */.X)(FN_START, callbackStart, this.featureName, baseEE);
    (0,register_handler/* registerHandler */.X)(CB_START, callbackStart, this.featureName, promiseEE);

    // register plugins
    var pluginApi = {
      getCurrentNode,
      setCurrentNode
    };
    (0,register_handler/* registerHandler */.X)('spa-register', function (init) {
      if (typeof init === 'function') {
        init(pluginApi);
      }
    }, features/* FEATURE_NAMES.spa */.DT.spa, baseEE);
    function callbackStart() {
      state.depth++;
      this.prevNode = state.currentNode;
      this.ct = state.childTime;
      state.childTime = 0;
      state.timerBudget = MAX_TIMER_BUDGET;
    }
    (0,register_handler/* registerHandler */.X)(FN_END, callbackEnd, this.featureName, baseEE);
    (0,register_handler/* registerHandler */.X)('cb-end', callbackEnd, this.featureName, promiseEE);
    function callbackEnd() {
      state.depth--;
      var totalTime = this.jsTime || 0;
      var exclusiveTime = totalTime - state.childTime;
      state.childTime = this.ct + totalTime;
      if (state.currentNode) {
        // transfer accumulated callback time to the active interaction node
        // run even if jsTime is 0 to update jsEnd
        state.currentNode.callback(exclusiveTime, this[FN_END]);
        if (this.isTraced) {
          state.currentNode.attrs.tracedTime = exclusiveTime;
        }
      }
      this.jsTime = state.currentNode ? 0 : exclusiveTime;
      setCurrentNode(this.prevNode);
      this.prevNode = null;
      state.timerBudget = MAX_TIMER_BUDGET;
    }
    (0,register_handler/* registerHandler */.X)(FN_START, function (args, eventSource) {
      var ev = args[0];
      var evName = ev.type;
      var eventNode = ev["__nrNode:".concat(bundle_id/* bundleId */.a)];
      if (!state.pageLoaded && (evName === 'load' && eventSource === window || runtime/* loadedAsDeferredBrowserScript */.LW)) {
        state.pageLoaded = true;
        // set to null so prevNode is set correctly
        this.prevNode = state.currentNode = null;
        if (state.initialPageLoad) {
          eventNode = state.initialPageLoad.root;

          // Even if initialPageLoad has remaining callbacks, force the initialPageLoad
          // interaction to complete when the page load event occurs.
          state.initialPageLoad[REMAINING] = 0;
          aggregate_originalSetTimeout(function () {
            INTERACTION_EVENTS.push('popstate');
          });
        }
      }
      if (eventNode) {
        // If we've already seen a previous handler for this specific event object,
        // just restore that. We want multiple handlers for the same event to share
        // a node.
        setCurrentNode(eventNode);
      } else if (evName === 'hashchange') {
        setCurrentNode(state.nodeOnLastHashUpdate);
        state.nodeOnLastHashUpdate = null;
      } else if (eventSource instanceof XMLHttpRequest) {
        // If this event was emitted by an XHR, restore the node ID associated with
        // that XHR.
        setCurrentNode(baseEE.context(eventSource).spaNode);
      } else if (!state.currentNode && INTERACTION_EVENTS.indexOf(evName) !== -1) {
        // Otherwise, if no interaction is currently active, create a new node ID,
        // and let the aggregator know that we entered a new event handler callback
        // so that it has a chance to possibly start an interaction.
        var ixn = new Interaction(evName, this[FN_START], state.lastSeenUrl, state.lastSeenRouteName, onInteractionFinished, agentRef.agentIdentifier);

        // Store the interaction as prevInteraction in case it is prematurely discarded
        state.prevInteraction = ixn;
        setCurrentNode(ixn.root);
        if (evName === 'click') {
          var value = getActionText(ev.target);
          if (value) {
            state.currentNode.attrs.custom.actionText = value;
          }
        }
      }
      ev["__nrNode:".concat(bundle_id/* bundleId */.a)] = state.currentNode;
    }, this.featureName, eventsEE);

    /**
     * *** TIMERS ***
     * setTimeout call needs to keep the interaction active in case a node is started
     * in its callback.
     */

    // The context supplied to this callback will be shared with the fn-start/fn-end
    // callbacks that fire around the callback passed to setTimeout originally.
    (0,register_handler/* registerHandler */.X)('setTimeout-end', function saveId(args, obj, timerId) {
      if (!state.currentNode || state.timerBudget - this.timerDuration < 0) return;
      if (args && !(args[0] instanceof Function)) return;
      state.currentNode[INTERACTION][REMAINING]++;
      this.timerId = timerId;
      state.timerMap[timerId] = state.currentNode;
      this.timerBudget = state.timerBudget - 50;
    }, this.featureName, timerEE);
    (0,register_handler/* registerHandler */.X)('clearTimeout-start', function clear(args) {
      var timerId = args[0];
      var node = state.timerMap[timerId];
      if (node) {
        var interaction = node[INTERACTION];
        interaction[REMAINING]--;
        interaction.checkFinish();
        delete state.timerMap[timerId];
      }
    }, this.featureName, timerEE);
    (0,register_handler/* registerHandler */.X)(FN_START, function () {
      state.timerBudget = this.timerBudget || MAX_TIMER_BUDGET;
      var id = this.timerId;
      var node = state.timerMap[id];
      setCurrentNode(node);
      delete state.timerMap[id];
      if (node) node[INTERACTION][REMAINING]--;
    }, this.featureName, timerEE);

    /**
     * *** XHR ***
     * - `new-xhr` event is fired when new instance of XHR is created. Here we create
     *    a new node and store it on the XHR object.
     * -  When the send method is called (`send-xhr-start` event), we tell the interaction
     *    to wait for this XHR to complete.
     * -  When any direct event handlers are invoked (`fn-start` on the `xhr` emitter),
     *    we restore the node in case other child nodes are started here.
     * -  Callbacks attached using `addEventListener` are handled using `fn-start` on the
     *    `events` emitter.
     * -  When `xhr-resolved` is emitted, we end the node. The node.finish() call also
     *    instructs the interaction to stop waiting for this node.
     */

    // context is shared with new-xhr event, and is stored on the xhr iteself.
    (0,register_handler/* registerHandler */.X)(FN_START, function () {
      setCurrentNode(this[SPA_NODE]);
    }, this.featureName, xhrEE);

    // context is stored on the xhr and is shared with all callbacks associated
    // with the new xhr
    (0,register_handler/* registerHandler */.X)('new-xhr', function () {
      if (!state.disableSpaFix && !state.currentNode && state.prevInteraction && !state.prevInteraction.ignored) {
        /*
         * The previous interaction was discarded before a route change. Restore the interaction
         * in case this XHR is associated with a route change.
         */
        const interaction = state.prevInteraction;
        state.currentNode = interaction.root;
        interaction.root.end = null;
      }
      if (state.currentNode) {
        this[SPA_NODE] = state.currentNode.child('ajax', null, null, true);
      }
    }, this.featureName, xhrEE);
    (0,register_handler/* registerHandler */.X)('send-xhr-start', function () {
      var node = this[SPA_NODE];
      if (node && !this.sent) {
        this.sent = true;
        node.dt = this.dt;
        if (node.dt?.timestamp) {
          node.dt.timestamp = agentRef.runtime.timeKeeper.correctAbsoluteTimestamp(node.dt.timestamp);
        }
        node.jsEnd = node.start = this.startTime;
        node[INTERACTION][REMAINING]++;
      }
    }, this.featureName, xhrEE);
    (0,register_handler/* registerHandler */.X)('xhr-resolved', function () {
      var node = this[SPA_NODE];
      if (node) {
        if (!(0,deny_list/* shouldCollectEvent */.zR)(this.params)) {
          node.cancel();
          return;
        }
        var attrs = node.attrs;
        attrs.params = this.params;
        attrs.metrics = this.metrics;
        node.finish(this.endTime);
        if (!!this.currentNode && !!this.currentNode.interaction) this.currentNode.interaction.checkFinish();
      }
    }, this.featureName, baseEE);

    /**
     * *** JSONP ***
     *
     */

    (0,register_handler/* registerHandler */.X)('new-jsonp', function (url) {
      if (state.currentNode) {
        var node = this[JSONP_NODE] = state.currentNode.child('ajax', this[FETCH_START]);
        node.start = this['new-jsonp'];
        this.url = url;
        this.status = null;
      }
    }, this.featureName, jsonpEE);
    (0,register_handler/* registerHandler */.X)('cb-start', function (args) {
      var node = this[JSONP_NODE];
      if (node) {
        setCurrentNode(node);
        this.status = 200;
      }
    }, this.featureName, jsonpEE);
    (0,register_handler/* registerHandler */.X)('jsonp-error', function () {
      var node = this[JSONP_NODE];
      if (node) {
        setCurrentNode(node);
        this.status = 0;
      }
    }, this.featureName, jsonpEE);
    (0,register_handler/* registerHandler */.X)(JSONP_END, function () {
      var node = this[JSONP_NODE];
      if (node) {
        // if no status is set then cb never fired - so it's not a valid JSONP
        if (this.status === null) {
          node.cancel();
          return;
        }
        var attrs = node.attrs;
        var params = attrs.params = {};
        var parsed = (0,parse_url/* parseUrl */.e)(this.url);
        params.method = 'GET';
        params.pathname = parsed.pathname;
        params.host = parsed.hostname + ':' + parsed.port;
        params.status = this.status;
        attrs.metrics = {
          txSize: 0,
          rxSize: 0
        };
        attrs.isJSONP = true;
        node.jsEnd = this[JSONP_END];
        node.jsTime = this[CB_START] ? this[JSONP_END] - this[CB_START] : 0;
        node.finish(node.jsEnd);
      }
    }, this.featureName, jsonpEE);
    (0,register_handler/* registerHandler */.X)(FETCH_START, function (fetchArguments, dtPayload) {
      if (fetchArguments) {
        if (!state.disableSpaFix && !state.currentNode && state.prevInteraction && !state.prevInteraction.ignored) {
          /*
           * The previous interaction was discarded before a route change. Restore the interaction
           * in case this XHR is associated with a route change.
           */
          const interaction = state.prevInteraction;
          state.currentNode = interaction.root;
          interaction.root.end = null;
        }
        if (state.currentNode) {
          this[SPA_NODE] = state.currentNode.child('ajax', this[FETCH_START]);
          if (dtPayload && this[SPA_NODE]) {
            this[SPA_NODE].dt = dtPayload;
            if (this[SPA_NODE].dt?.timestamp) {
              this[SPA_NODE].dt.timestamp = agentRef.runtime.timeKeeper.correctAbsoluteTimestamp(this[SPA_NODE].dt.timestamp);
            }
          }
        }
      }
    }, this.featureName, fetchEE);
    (0,register_handler/* registerHandler */.X)(FETCH_BODY + 'start', function (args) {
      if (state.currentNode) {
        this[SPA_NODE] = state.currentNode;
        state.currentNode[INTERACTION][REMAINING]++;
      }
    }, this.featureName, fetchEE);
    (0,register_handler/* registerHandler */.X)(FETCH_BODY + 'end', function (args, ctx, bodyPromise) {
      var node = this[SPA_NODE];
      if (node) node[INTERACTION][REMAINING]--;
    }, this.featureName, fetchEE);
    (0,register_handler/* registerHandler */.X)(FETCH_DONE, function (err, res) {
      var node = this[SPA_NODE];
      if (node) {
        if (err || !(0,deny_list/* shouldCollectEvent */.zR)(this.params)) {
          node.cancel();
          return;
        }
        var attrs = node.attrs;
        attrs.params = this.params;
        attrs.metrics = {
          txSize: this.txSize,
          rxSize: this.rxSize
        };
        attrs.isFetch = true;
        node.finish(this[FETCH_DONE]);
      }
    }, this.featureName, fetchEE);
    (0,register_handler/* registerHandler */.X)('newURL', function (url, hashChangedDuringCb) {
      if (state.currentNode) {
        state.currentNode[INTERACTION].setNewURL(url);
      } else if (state.prevInteraction && !state.prevInteraction.ignored) {
        /*
         * The previous interaction was discarded before the route was changed. This can happen in SPA
         * frameworks when using lazy loading. We have also seen this in version 11+ of Nextjs where
         * some route changes re-use cached resolved promises.
         */
        const interaction = state.prevInteraction;
        interaction.setNewURL(url);
        interaction.root.end = null;
        setCurrentNode(interaction.root);
      }
      if (state.currentNode) {
        if (state.lastSeenUrl !== url) {
          state.currentNode[INTERACTION].routeChange = true;
        }
        if (hashChangedDuringCb) {
          state.nodeOnLastHashUpdate = state.currentNode;
        }
      }
      state.lastSeenUrl = url;
    }, this.featureName, historyEE);

    /**
     * SCRIPTS
     *   This is only needed to keep the interaction open while external scripts are being loaded.
     *   The script that is loaded could continue the interaction by making additional AJAX
     *   calls or changing the URL. The interaction context (currentNode) needs to be
     *   restored somehow, but this differs based on the specific customer code. In some cases, we
     *   could wrap a JSONP callback, in other cases we could wrap a higher-level API, and in
     *   some cases we may not be able to restore context automatically (customer would need
     *   to instrument their code manually).
     *
     * - We do not restore the original context in the load/error callbacks. This would not
     *   work for the scripts themselves because by the time the load event fires, the
     *   script content has already been executed.
     */

    // dom-start is emitted when appendChild or replaceChild are called. If the element being
    // inserted is script and we are inside an interaction, we will keep the interaction open
    // until the script is loaded.
    jsonpEE.on('dom-start', function (args) {
      if (!state.currentNode) return;
      var el = args[0];
      var isScript = el && el.nodeName === 'SCRIPT' && el.src !== '';
      var interaction = state.currentNode.interaction;
      if (isScript) {
        // increase remaining count to keep the interaction open
        interaction[REMAINING]++;
        el.addEventListener('load', onload, (0,event_listener_opts/* eventListenerOpts */.m$)(false));
        el.addEventListener('error', onerror, (0,event_listener_opts/* eventListenerOpts */.m$)(false));
      }
      function onload() {
        // decrease remaining to allow interaction to finish
        interaction[REMAINING]--;

        // checkFinish is what initiates closing interaction, but is only called
        // when setCurrentNode is called. Since we are not restoring a node here,
        // we need to initiate the check manually.
        // The reason we are not restoring the node here is because 1) this is not
        // where the code of the external script runs (by the time the load event
        // fires, it has already executed), and 2) it would require storing the context
        // probably on the DOM node and restoring in all callbacks, which is a different
        // use case than lazy loading.
        interaction.checkFinish();
      }
      function onerror() {
        interaction[REMAINING]--;
        interaction.checkFinish();
      }
    });
    (0,register_handler/* registerHandler */.X)(FN_START, function () {
      setCurrentNode(state.prevNode);
    }, this.featureName, mutationEE);
    (0,register_handler/* registerHandler */.X)('resolve-start', resolvePromise, this.featureName, promiseEE);
    (0,register_handler/* registerHandler */.X)('executor-err', resolvePromise, this.featureName, promiseEE);
    (0,register_handler/* registerHandler */.X)('propagate', saveNode, this.featureName, promiseEE);
    (0,register_handler/* registerHandler */.X)(CB_START, function () {
      var ctx = this.getCtx ? this.getCtx() : this;
      setCurrentNode(ctx[SPA_NODE]);
    }, this.featureName, promiseEE);
    (0,register_handler/* registerHandler */.X)(INTERACTION_API + 'get', function (t) {
      var interaction;
      if (state?.currentNode?.[INTERACTION]) interaction = this.ixn = state.currentNode[INTERACTION];else if (state?.prevNode?.end === null && state?.prevNode?.[INTERACTION]?.root?.[INTERACTION]?.eventName !== 'initialPageLoad') interaction = this.ixn = state.prevNode[INTERACTION];else interaction = this.ixn = new Interaction('api', t, state.lastSeenUrl, state.lastSeenRouteName, onInteractionFinished, agentRef.agentIdentifier);
      if (!state.currentNode) {
        interaction.checkFinish();
        if (state.depth) setCurrentNode(interaction.root);
      }
    }, this.featureName, baseEE);
    (0,register_handler/* registerHandler */.X)(INTERACTION_API + 'actionText', function (t, actionText) {
      var customAttrs = this.ixn.root.attrs.custom;
      if (actionText) customAttrs.actionText = actionText;
    }, this.featureName, baseEE);
    (0,register_handler/* registerHandler */.X)(INTERACTION_API + 'setName', function (t, name, trigger) {
      var attrs = this.ixn.root.attrs;
      if (name) attrs.customName = name;
      if (trigger) attrs.trigger = trigger;
    }, this.featureName, baseEE);
    (0,register_handler/* registerHandler */.X)(INTERACTION_API + 'setAttribute', function (t, name, value) {
      this.ixn.root.attrs.custom[name] = value;
    }, this.featureName, baseEE);
    (0,register_handler/* registerHandler */.X)(INTERACTION_API + 'end', function (timestamp) {
      var interaction = this.ixn;
      var node = activeNodeFor(interaction);
      setCurrentNode(null);
      node.child('customEnd', timestamp)?.finish(timestamp);
      interaction.finish();
    }, this.featureName, baseEE);
    (0,register_handler/* registerHandler */.X)(INTERACTION_API + 'ignore', function (t) {
      this.ixn.ignored = true;
    }, this.featureName, baseEE);
    (0,register_handler/* registerHandler */.X)(INTERACTION_API + 'save', function (t) {
      this.ixn.save = true;
    }, this.featureName, baseEE);
    (0,register_handler/* registerHandler */.X)(INTERACTION_API + 'tracer', function (timestamp, name, store) {
      var interaction = this.ixn;
      var parent = activeNodeFor(interaction);
      var ctx = baseEE.context(store);
      if (!name) {
        ctx.inc = ++interaction[REMAINING];
        return ctx[SPA_NODE] = parent;
      }
      ctx[SPA_NODE] = parent.child('customTracer', timestamp, name);
    }, this.featureName, baseEE);
    (0,register_handler/* registerHandler */.X)(FN_START, tracerDone, this.featureName, tracerEE);
    (0,register_handler/* registerHandler */.X)('no-' + FN_START, tracerDone, this.featureName, tracerEE);
    function tracerDone(timestamp, interactionContext, hasCb) {
      var node = this[SPA_NODE];
      if (!node) return;
      var interaction = node[INTERACTION];
      var inc = this.inc;
      this.isTraced = true;
      if (inc) {
        interaction[REMAINING]--;
      } else if (node) {
        node.finish(timestamp);
      }
      hasCb ? setCurrentNode(node) : interaction.checkFinish();
    }
    (0,register_handler/* registerHandler */.X)(INTERACTION_API + 'getContext', function (t, cb) {
      var store = this.ixn.root.attrs.store;
      setTimeout(function () {
        cb(store);
      }, 0);
    }, this.featureName, baseEE);
    (0,register_handler/* registerHandler */.X)(INTERACTION_API + 'onEnd', function (t, cb) {
      this.ixn.handlers.push(cb);
    }, this.featureName, baseEE);
    (0,register_handler/* registerHandler */.X)('api-routeName', function (t, currentRouteName) {
      state.lastSeenRouteName = currentRouteName;
      if (state.currentNode) state.currentNode[INTERACTION].setNewRoute(currentRouteName);
    }, this.featureName, baseEE);
    function activeNodeFor(interaction) {
      return state.currentNode && state.currentNode[INTERACTION] === interaction ? state.currentNode : interaction.root;
    }
    function saveNode(val, overwrite) {
      if (overwrite || !this[SPA_NODE]) this[SPA_NODE] = state.currentNode;
    }
    function resolvePromise() {
      if (!this.resolved) {
        this.resolved = true;
        this[SPA_NODE] = state.currentNode;
      }
    }
    function getCurrentNode() {
      return state.currentNode;
    }
    function setCurrentNode(newNode) {
      if (!state.pageLoaded && !newNode && state.initialPageLoad) newNode = state.initialPageLoad.root;
      if (state.currentNode) {
        state.currentNode[INTERACTION].checkFinish();
      }
      state.prevNode = state.currentNode;
      state.currentNode = newNode && !newNode[INTERACTION].root.end ? newNode : null;
    }
    function onInteractionFinished(interaction) {
      if (interaction === state.initialPageLoad) state.initialPageLoad = null;
      var root = interaction.root;
      var attrs = root.attrs;

      // make sure that newrelic[INTERACTION]() works in end handler
      state.currentNode = root;
      Object.values(interaction.handlers || {}).forEach(function (cb) {
        cb(attrs.store);
      });
      setCurrentNode(null);
    }
    baseEE.on('spa-jserror', function (type, name, params, metrics) {
      if (!state.currentNode) return;
      params._interactionId = state.currentNode.interaction.id;
      // do not capture parentNodeId when in root node
      if (state.currentNode.type && state.currentNode.type !== 'interaction') {
        params._interactionNodeId = state.currentNode.id;
      }
    });
    (0,register_handler/* registerHandler */.X)('function-err', function (args, obj, error) {
      if (!state.currentNode) return;
      error.__newrelic ??= {};
      error.__newrelic[agentRef.agentIdentifier] = {
        interactionId: state.currentNode.interaction.id
      };
      if (state.currentNode.type && state.currentNode.type !== 'interaction') {
        error.__newrelic[agentRef.agentIdentifier].interactionNodeId = state.currentNode.id;
      }
    }, this.featureName, baseEE);
    baseEE.on('interaction', saveInteraction);
    function getActionText(node) {
      var nodeType = node.tagName.toLowerCase();
      var goodNodeTypes = ['a', 'button', 'input'];
      var isGoodNode = goodNodeTypes.indexOf(nodeType) !== -1;
      if (isGoodNode) {
        return node.title || node.value || node.innerText;
      }
    }
    function saveInteraction(interaction) {
      if (interaction.ignored || !interaction.save && !interaction.routeChange) {
        baseEE.emit('interactionDone', [interaction, false]);
        return;
      }
      if (state.prevInteraction === interaction) {
        // If the interaction is being saved, remove it from prevInteraction variable
        // to prevent the interaction from possibly being sent twice or causing an internal
        // recursive loop issue.
        state.prevInteraction = null;
      }

      // assign unique id, this is serialized and used to link interactions with errors
      interaction.root.attrs.id = (0,unique_id/* generateUuid */.Rl)();
      if (interaction.root.attrs.trigger === 'initialPageLoad') {
        interaction.root.attrs.firstPaint = first_paint/* firstPaint.current.value */.U.current.value;
        interaction.root.attrs.firstContentfulPaint = first_contentful_paint/* firstContentfulPaint.current.value */.y.current.value;
      }
      baseEE.emit('interactionDone', [interaction, true]);
      classThis.events.add(interaction);
      let smCategory;
      if (interaction.root?.attrs?.trigger === 'initialPageLoad') smCategory = 'InitialPageLoad';else if (interaction.routeChange) smCategory = 'RouteChange';else smCategory = 'Custom';
      (0,handle/* handle */.p)(metrics_constants/* SUPPORTABILITY_METRIC_CHANNEL */.xS, ["Spa/Interaction/".concat(smCategory, "/Duration/Ms"), Math.max((interaction.root?.end || 0) - (interaction.root?.start || 0), 0)], undefined, features/* FEATURE_NAMES.metrics */.DT.metrics, baseEE);
      if (!harvester) {
        (0,console/* warn */.Z)(19);
        return;
      }
      harvester.triggerHarvestFor(classThis);
    }
  }
  serializer(eventBuffer) {
    return this.spaSerializerClass.serializeMultiple(eventBuffer, 0, nav_timing/* navTimingValues */.zJ);
  }
}

/***/ })

}]);